import { formatError } from "kreate-common/modules/displayable-error";
import ButtonOutline from "kreate-common/modules/kreate-ui/components/ButtonOutline";
import ModalV2 from "kreate-common/modules/kreate-ui/components/ModalV2";
import { MdOutlineSentimentVeryDissatisfied } from "react-icons/md";

import styles from "./index.module.scss";

type Props = {
  open: boolean;
  onClose?: () => void;
  title?: string;
  description?: string;
  debug?: unknown;
};

export default function ModalFailure({
  open,
  onClose,
  title,
  description,
  debug,
}: Props) {
  return (
    <ModalV2 open={open} onClose={onClose} closeOnDimmerClick={false}>
      <ModalV2.Content style={{ paddingTop: "56px" }}>
        <MdOutlineSentimentVeryDissatisfied
          size="64px"
          className={styles.icon}
        />
        {title ? <div className={styles.title}>{title}</div> : null}
        {description ? (
          <div className={styles.description}>{description}</div>
        ) : null}
        {debug ? (
          <div className={styles.debug}>{formatError(debug)}</div>
        ) : null}
      </ModalV2.Content>
      <ModalV2.Actions>
        <ButtonOutline size="lg" content="Close" onClick={onClose} />
      </ModalV2.Actions>
    </ModalV2>
  );
}
